


















































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ISignUpFields, ICognitoSignUpFields } from '@/common/types';

// components
import Base from '@/components/Login/Base.vue';
import Welcome from '@/components/Global/Welcome.vue';
import Validation from '@/components/Form/Validation.vue';
import TextField from '@/components/Form/TextField.vue';
import Alert from '@/components/Global/Alert.vue';
import SelectField from '@/components/Form/SelectField.vue';
import RadioField from '@/components/Form/RadioField.vue';
import Checkbox from '@/components/Form/Checkbox.vue';
// Services
import router from '../../router';
import Brand from '@/services/Brand';
import store from '@/store';
import AuthService from '@/services/Auth';
import Loading from '@/components/Global/Loading.vue';
// validations
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators';
import { helpers } from 'vuelidate/lib/validators';
import { hasUppercase, hasLowercase, hasNumber, hasSpecialCharacter } from '@/validations';

@Component({
	name: 'ConfirmSignIn',
	components: {
		TextField,
		Alert,
		Validation,
		SelectField,
		RadioField,
		Base,
		Welcome,
		Checkbox,
		Loading
	},
	validations: {
		form: {},
	},
})
export default class ConfirmSignIn extends Vue {
	@Prop(String) private confirmSignInConfig: any;
	@Prop(String) private email: any;
	@Prop(String) private authenticationDetails: any;
	private loading: boolean;
	private isInvalid: boolean;
	private verifyAttr: string;
	private error: string | boolean;
	private logger: any;
	private form: {
		code: string;
	};
	private auth: any;
	private newCodeSent: boolean;
	private destination: string;
	constructor() {
		super();
		this.loading = false;
		this.isInvalid = false;
		this.verifyAttr = '';
		this.error = '';
		this.logger = {};
		this.form = {
			code: ''
		};
		this.auth = '';
		this.newCodeSent = false;
		this.destination = '';
	}

	private isInValid() {
		return this.$v.$invalid;
	}

	get details() {
		return Brand.getBrandInformation();
	}
	private created() {
		this.auth = this.$route.params.authenticationDetails;

		this.destination = this.options.mfaPreference !== 'SMS' ? this.options.email : this.options.phone_number;
	}

	get options() {
		const defaults = {
			confirmSignInConfig: '',
			authenticationDetails: null,
			email: '',
			phone_number: '',
			mfaPreference : ''
		};
		return Object.assign(defaults, this.$route.params || {});
	}

	private async requestNewCode() {
		try {
			this.loading = true;
			console.log('Resending code now.');
			// @ts-ignore
			const emailAddress = this.$route.params.email;
			const password = this.$route.params.password;
			const resendSignInCode = await this.$Amplify.Auth.signIn(emailAddress, password);

			this.newCodeSent = true;
			this.auth = resendSignInCode;
			this.loading = false;
		} catch (e) {
			this.error = 'There was an error trying to resend the code, please try again.';
		}
	}

	private async submit() {
		this.error = false;
		this.isInvalid = false;
		this.$v.$touch();
		this.loading = true;
		if (this.$v.$invalid) {
			this.isInvalid = true;
			this.loading = false;
			window.scrollTo(0, 0);
			return;
		}
		const that = this;

		try {
			const checkChallenge = await this.$Amplify.Auth.sendCustomChallengeAnswer(
				this.auth,
				this.form.code,
			);

			this.signedIn();
		} catch (e) {
			console.log('Resend code because it was incorrect.');
			// this.send();
			that.loading = false;
			that.error = true;
			// that.logger.error('Security code entered was incorrect. Re-Enter your code!');
			window.scrollTo(0, 0);
		}
	}

	private async signedIn() {
		this.loading = true;
		const session = await this.$Amplify.Auth.currentSession();

		this.$store.dispatch('Auth/authenticated').then(
			async response => {
				try {
					await AuthService.redirectToUrl();
				} catch (e) {
					this.$router.push({
						name: 'home',
					});
				}
			},
			error => {
				this.$router.push({
					name: 'register-signin',
					params: {
						error: true,
					},
				});
			},
		);
	}

}
